import { createContext } from "use-context-selector"

import { createProvider } from "domain/createProvider"
import { getDataGridInitState } from "domain/utils"

const initState = getDataGridInitState()

export const CashFlowContext = createContext(initState)

export const CashFlowProvider = createProvider(CashFlowContext, initState)
